import { useEffect } from "react";
import FooterContact from "../../FooterContactPage/FooterContact";
import DataAnalyticsBanner from "../../HomePage/Services/DataAnalyticsBanner";
import DataAnalyticsFQA from "../../HomePage/Services/DataAnalyticsFQA";
import ServicesWeOffer from "./ServicesWeOffer/ServicesWeOffer";
import QuickNav from "../../HomePage/HeroSection/QuickNav";
import { Helmet } from "react-helmet-async";

const DataAnalysis = () => {
  const QuickNavItems = ["Services", "Industry", "FAQ", "Form"];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <>
      <Helmet>
        <title>Data Analytics Services in Bangladesh | Quad Theory Ltd</title>
        <meta
          name="description"
          content="Quad Theory Ltd provides data analytics services in Bangladesh that turn scattered business data into clear, actionable insights. Industry focused analytics built to support confident decisions, not just dashboards."
        />
      </Helmet>
      </>
      <DataAnalyticsBanner />
      <div
        style={{ backgroundColor: "#0b4f5d", }}
      >
        <QuickNav items={QuickNavItems} />
        <ServicesWeOffer />
        <DataAnalyticsFQA />
        <FooterContact />
      </div>
    </div>
  );
};

export default DataAnalysis;
